jQuery(document).ready(function ($) {
    var $carousels = $('.evblocks-installation-step__carousel');

    if (!$carousels.length) return;
    if (typeof $.fn.slick === 'undefined') {
        console.warn('Slick slider is not loaded.');
        return;
    }

    $carousels.each(function () {
        $(this).slick({
            dots: true,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: '<button type="button" class="slick-prev custom-arrow">&#x25C0;</button>', // ◀
            nextArrow: '<button type="button" class="slick-next custom-arrow">&#x25B6;</button>', // ▶
        });
    });
});
